export default __webpack_public_path__ + "static/media/uefa-predic.13306edb.webp";